import { enqueueSnackbar } from "notistack";

const UIText = {
  "es-CL": { error: "Fallo al intentar descargar el archivo adjunto " },
  "en-US": { error: "Error trying to download the attached file " },
};

// Downloads a Teams channel attachment through the /download/channel/attachment
// endpoint (the channel equivalent of /download/attachment for mail).
const downloadChannelAttachment = ({ M365server, cloner_key, id, name, locale }) => {
  const { error } = UIText[locale];
  // https://itnext.io/how-to-download-files-with-javascript-d5a69b749896
  return async () => {
    try {
      let newURL = new URL(`${M365server}download/channel/attachment`);
      newURL.searchParams.append("cloner_key", cloner_key);
      newURL.searchParams.append("attachment_id", id);

      const anchor = document.createElement("a");
      anchor.href = newURL;

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch (e) {
      console.error(e);
      enqueueSnackbar(`${error} ${name}: ${e.message}`, { variant: "error" });
    }
  };
};

export default downloadChannelAttachment;
